<template>
  <el-popover
    ref="popover"
    v-model="showPortalsFlag"
    :disabled="portalLetters.length < 1"
    :width="80"
    popperClass="portal-popover"
    trigger="focus"
  >
    <div v-if="portalLetters.length > 0" class="portals">
      <div
        v-for="letter in portalLetters"
        :key="letter"
        class="portal"
        type="text"
        @click="handleSetLetter(letter)"
      >
        <span v-if="letter">{{ letter }}</span>
        <span v-else v-html="'<i>Sin letra</i>'"></span>
      </div>
    </div>
    <div v-else class="text-center">
      <i>No hay letras registradas</i>
    </div>
    <el-input
      slot="reference"
      v-model="internalValue"
      :class="{ highlight: portalLetters.length > 1 }"
      :disabled="$attrs.disabled"
      :tabindex="tabindex"
      placeholder="Sin letra"
      @change="handleUpdateLetter"
    />
  </el-popover>
</template>

<script>
import cache from "@/mixins/cache";
import { escapeRegExp } from "@/utils/regexp";
import { sortByValue } from "@/utils/sorters";

export default {
  name: "PortalLetterSelector",
  mixins: [cache],
  props: {
    value: [String, Number],
    street: Object,
    portal: [String, Number],
    workgroupId: Number,
    tabindex: [String, Number],
  },
  data() {
    return {
      persistedCache: true,
      showPortalsFlag: false,
      internalValue: null,
    };
  },
  computed: {
    portalLetters() {
      return this.portals
        .filter((p) => p.number === parseInt(this.portal))
        .map((p) => p.letter)
        .sort(sortByValue);
    },
    portals() {
      return this.street?.portals || [];
    },
  },
  watch: {
    value() {
      this.internalValue = this.value;
    },
    portal() {
      if (this.portalLetters.length > 0 && this.portalLetters[0] !== this.internalValue) {
        this.$emit("input", this.portalLetters[0] || null);
      }
    },
  },
  created() {
    this.internalValue = this.value;
  },
  methods: {
    replaceWithLetterIfExists() {
      if (this.internalValue && !this.portalLetters.includes(this.internalValue)) {
        const re = new RegExp(escapeRegExp(this.internalValue), "i");
        const found = this.portalLetters.filter((p) => p).find((p) => p.match(re));
        if (found) {
          this.internalValue = found;
        }
      }
    },
    handleSetLetter(letter) {
      this.internalValue = letter;
      if (this.internalValue !== this.value) {
        this.replaceWithLetterIfExists();
        this.$emit("input", letter || null);
      }
      this.$refs.popover.doClose();
    },
    handleUpdateLetter() {
      if (this.internalValue !== this.value) {
        this.replaceWithLetterIfExists();
        this.$emit("input", this.internalValue || null);
      }
      this.$refs.popover.doClose();
    },
  },
};
</script>

<style>
.portal-popover {
  min-width: auto;
}
</style>

<style lang="scss" scoped>
.portals-dropdown-arrow {
  right: 4px;
  top: -1px;
  font-size: 14px;
  position: absolute;
  color: #5a5b67;
}

.portals {
  display: flex;
  flex-direction: column;
  max-height: 210px;
  overflow-y: auto;
}

.portal {
  flex: 1;
  text-align: center;
  cursor: pointer;
  display: block;
  width: 100%;
  font-size: 12px;
  padding: 4px 0;

  &.active {
    font-weight: bold;
    color: $menuActiveText;
  }
}

::v-deep .highlight .el-input__inner {
  animation: blink 1s;
  animation-iteration-count: 5;
}

@keyframes blink {
  50% {
    box-shadow: 0 0 0 3px #c03639;
  }
}
</style>
